import { Enum_ForecastElement } from "erayic-com-pack/utils/attribute/Element";
import { Ref } from "vue";
import { Container_Config } from "erayic-com-pack/component/Container/Container.config";
import mapboxgl from "mapbox-gl";
import { ElementOptionList, MapProps } from "./ModeComapare.type";
import { MapBasicVectorSource } from "erayic-com-pack/component/NewMap/Map.config";
import { windSvg } from "@/assets/img/windSvg";

/** 要素可选项列表 */
const elementList: ElementOptionList[] = [
  {
    title: "降水", element: [
      { title: "1h", key: Enum_ForecastElement.PRE01, isMulti: false, markerLabel: "降水" },
      { title: "3h", key: Enum_ForecastElement.PRE03, isMulti: false, markerLabel: "降水" },
      { title: "6h", key: Enum_ForecastElement.PRE06, isMulti: false, markerLabel: "降水" },
      { title: "12h", key: Enum_ForecastElement.PRE12, isMulti: false, markerLabel: "降水" },
      { title: "24h", key: Enum_ForecastElement.PRE24, isMulti: false, markerLabel: "降水" }
    ]
  },
  { title: "气温", element: [{ title: "1h", key: Enum_ForecastElement.TEM01, isMulti: false, markerLabel: "气温" }] },
  { title: "最高温", element: [{ title: "24h", key: Enum_ForecastElement.TMAX, isMulti: false, markerLabel: "气温" }] },
  { title: "最低温", element: [{ title: "24h", key: Enum_ForecastElement.TMIN, isMulti: false, markerLabel: "气温" }] },
  { title: "平均风", element: [{ title: "1h", key: Enum_ForecastElement.UV01, isMulti: false, markerLabel: "风速" }] },
  { title: "阵风", element: [{ title: "1h", key: Enum_ForecastElement.GUST01, isMulti: false, markerLabel: "风速" }] },
  { title: "最大风", element: [{ title: "24h", key: Enum_ForecastElement.UVA, isMulti: false, markerLabel: "风速" }] },
  { title: "最大阵风", element: [{ title: "24h", key: Enum_ForecastElement.GMAX, isMulti: false, markerLabel: "风速" }] },
  { title: "相对湿度", element: [{ title: "1h", key: Enum_ForecastElement.RH01, isMulti: false, markerLabel: "湿度" }] },
  { title: "最大相对湿度", element: [{ title: "24h", key: Enum_ForecastElement.RHA, isMulti: false, markerLabel: "湿度" }] },
  { title: "最小相对湿度", element: [{ title: "24h", key: Enum_ForecastElement.RHI, isMulti: false, markerLabel: "湿度" }] },
  { title: "云量", element: [{ title: "1h", key: Enum_ForecastElement.TCC01, isMulti: false, markerLabel: "云量" }] },
  { title: "最大云量", element: [{ title: "24h", key: Enum_ForecastElement.TCA, isMulti: false, markerLabel: "云量" }] },
  { title: "能见度", element: [{ title: "1h", key: Enum_ForecastElement.VIS01, isMulti: false, markerLabel: "能见度" }] },
  { title: "最小能见度", element: [{ title: "24h", key: Enum_ForecastElement.VMIN, isMulti: false, markerLabel: "能见度" }] },
  { title: "多层次气温", element: [{ title: "1h", key: Enum_ForecastElement.L_TEM, isMulti: true, markerLabel: "气温" }] },
  { title: "多层次露点温度", element: [{ title: "1h", key: Enum_ForecastElement.L_DPT, isMulti: true, markerLabel: "露点温" }] },
  { title: "多层次平均风", element: [{ title: "1h", key: Enum_ForecastElement.L_WIUV, isMulti: true, markerLabel: "风速" }] },
  { title: "多层次相对湿度", element: [{ title: "1h", key: Enum_ForecastElement.L_RHU, isMulti: true, markerLabel: "湿度" }] },
  { title: "多层次云量", element: [{ title: "1h", key: Enum_ForecastElement.L_CLCO, isMulti: true, markerLabel: "云量" }] }
];

/** 多层次要素 */
const multiElementList = [Enum_ForecastElement.L_TEM, Enum_ForecastElement.L_DPT, Enum_ForecastElement.L_WIUV, Enum_ForecastElement.L_RHU];

// 要素及起报时间面板
const ModeCompareElementPanelContainer: Container_Config = {
  BaseProp: {
    Name: "ModeCompareElementPanel",
    Title: "模式预报",
    IsDisplayTitle: false,
    IsDisplayClose: false,
    IsDisplayFold: false,
    GroupName: "ModeForecast",
  },
  IsDrag: false,
  IsDisplay: true,
  ClassName: "container-style_3"
};

/** 地图组件初始化 */
const InitializeMap = async (container: string, mapProps: Ref<MapProps>): Promise<mapboxgl.Map> => {
  const mapStyle: mapboxgl.Style | string = {
    version: 8,
    sources: MapBasicVectorSource,
    layers: [
      { id: "world", source: "world", type: "fill", paint: { "fill-color": "#fff", "fill-outline-color": "rgba(108, 112, 117, 0.5)" } },
      { id: "world_line", source: "world", type: "line", paint: { "line-color": "rgba(108, 112, 117, 0.5)" } },
      { id: "sjxzqx", source: "sjxzqx", type: "line", paint: { "line-color": "#6C7075", "line-width": 1 } },
      { id: "zgbj", source: "zgbj", type: "line", paint: { "line-color": "#6C7075", "line-width": 1 } },
      { id: "HNPolygon", source: "HNPolygon", minzoom: 4, type: "line", paint: { "line-color": "#6C7075", "line-width": 1 } },
      { id: "gjxz", source: "gjxz", type: "line", paint: { "line-color": "#6C7075", "line-width": 3, "line-opacity": 0.8 } }
    ],
    glyphs: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf"
  };
  mapboxgl.accessToken = "";
  
  const MapOptions: mapboxgl.MapboxOptions = {
    style: mapStyle,
    container: container, // DIV容器
    antialias: true, // 抗锯齿
    renderWorldCopies: true, // 地图横向复制
    // @ts-expect-error what can i say?
    useWebGL2: true,
    dragRotate: false,
    doubleClickZoom: false,
    keyboard: false,
    ...mapProps.value
  };

  const map = new mapboxgl.Map(MapOptions);

  // 加入风羽图片
  const scale = 0.65;
  for(let key in windSvg) {
    const image = new Image(windSvg[key].width * scale, windSvg[key].height * scale);
    image.onload = () => map.addImage("wind_" + key, image);
    image.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(windSvg[key].svg);
  }
  
  return map;
};

/** 根据要素取Marker展示label */
const getMarkerLabel = (ele?: Enum_ForecastElement): string => {
  let markerLabel = "";
  if (ele)
    for (let i = 0; i < elementList.length; i++) {
      for (let j = 0; j < elementList[i].element.length; j++)
        if (elementList[i].element[j].key === ele) {
          markerLabel = elementList[i].element[j].markerLabel;
          break;
        }
      if (markerLabel) break;
    }
  return markerLabel;
};

/** mapbox-draw绘制插件初始化参数 */
const mapboxDrawParams = {
  displayControlsDefault: false,
  styles: [
    {
      "id": "gl-draw-line",
      "type": "line",
      "filter": ["all", ["==", "$type", "LineString"], ["!=", "mode", "static"]],
      "layout": {
        "line-cap": "round",
        "line-join": "round"
      },
      "paint": {
        "line-color": "#000",
        "line-dasharray": [0.2, 2],
        "line-width": 2
      }
    },
    // polygon fill
    {
      "id": "gl-draw-polygon-fill",
      "type": "fill",
      "filter": ["all", ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
      "paint": {
        "fill-color": "#000",
        "fill-outline-color": "#000",
        "fill-opacity": 0.1
      }
    },
    // polygon mid points
    {
      'id': 'gl-draw-polygon-midpoint',
      'type': 'circle',
      'filter': ['all',
        ['==', '$type', 'Point'],
        ['==', 'meta', 'midpoint']],
      'paint': {
        'circle-radius': 3,
        'circle-color': '#fbb03b'
      }
    },
    // polygon outline stroke
    // This doesn't style the first edge of the polygon, which uses the line stroke styling instead
    {
      "id": "gl-draw-polygon-stroke-active",
      "type": "line",
      "filter": ["all", ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
      "layout": {
        "line-cap": "round",
        "line-join": "round"
      },
      "paint": {
        "line-color": "#000",
        "line-dasharray": [0.2, 2],
        "line-width": 2
      }
    },
    // vertex point halos
    {
      "id": "gl-draw-polygon-and-line-vertex-halo-active",
      "type": "circle",
      "filter": ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"], ["!=", "mode", "static"]],
      "paint": {
        "circle-radius": 5,
        "circle-color": "#FFF"
      }
    },
    // vertex points
    {
      "id": "gl-draw-polygon-and-line-vertex-active",
      "type": "circle",
      "filter": ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"], ["!=", "mode", "static"]],
      "paint": {
        "circle-radius": 3,
        "circle-color": "#000",
      }
    },

    // INACTIVE (static, already drawn)
    // line stroke
    {
      "id": "gl-draw-line-static",
      "type": "line",
      "filter": ["all", ["==", "$type", "LineString"], ["==", "mode", "static"]],
      "layout": {
        "line-cap": "round",
        "line-join": "round"
      },
      "paint": {
        "line-color": "#000",
        "line-width": 3
      }
    },
    // polygon fill
    {
      "id": "gl-draw-polygon-fill-static",
      "type": "fill",
      "filter": ["all", ["==", "$type", "Polygon"], ["==", "mode", "static"]],
      "paint": {
        "fill-color": "#000",
        "fill-outline-color": "#000",
        "fill-opacity": 0.1
      }
    },
    // polygon outline
    {
      "id": "gl-draw-polygon-stroke-static",
      "type": "line",
      "filter": ["all", ["==", "$type", "Polygon"], ["==", "mode", "static"]],
      "layout": {
        "line-cap": "round",
        "line-join": "round"
      },
      "paint": {
        "line-color": "#000",
        "line-width": 3
      }
    }
  ]
};

export {
  mapboxDrawParams, ModeCompareElementPanelContainer, elementList, multiElementList,
  InitializeMap, getMarkerLabel
}